import { SeoConfig } from '@common';
import { Config } from '@config';

export const seoConfigFactory = (config: Config): SeoConfig => ({
  baseUrl: config.canonicalBaseUrl,
  hostUrl: config.canonicalBaseUrl,
  seoDescription: config.seoData.seoDescription,
  seoKeywords: config.seoData.seoKeywords,
  seoOpenGraph: config.seoData.seoOpenGraph,
  seoTitle: config.seoData.seoTitle,
});
